import {
	DONE,
	IN_PROGRESS,
	TODO,
	UNDEFINED,
	statusCategoryForId,
} from '@atlassian/jira-common-constants/src/status-categories.tsx';
import type { StatusValue } from '@atlassian/jira-issue-field-status/src/common/types.tsx';

const appearanceMap = {
	[UNDEFINED]: 'default',
	[TODO]: 'default',
	[DONE]: 'success',
	[IN_PROGRESS]: 'inprogress',
} as const;

export const transformValue = (value: StatusValue): { value: string; label: string }[] => {
	if (!value) {
		return [];
	}
	const valuesArray = Array.isArray(value) ? value : [value];
	return valuesArray.map(({ name }) => ({
		value: name,
		label: name,
	}));
};

export const toAppearance = (statusValue: StatusValue) =>
	statusValue.statusCategory.id
		? appearanceMap[statusCategoryForId(statusValue.statusCategory.id)]
		: appearanceMap[UNDEFINED];
